import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService } from 'ng2-webstorage';

import { API } from '../constants/api.constants';
import { SystemSettingStorageService } from '../utils/system-setting-storage.service';
import { CompanyService } from '../services/company/company.service';

@Injectable()
export class AuthServerProvider {
    constructor(
        private http: Http,
        private $localStorage: LocalStorageService,
        private companyService: CompanyService,
    ) {}

    getToken() {
        return this.$localStorage.retrieve('authenticationToken');
    }

    getInfo() {
        const jsonInfo = this.$localStorage.retrieve('authenticationInfo');

        if (jsonInfo) {
            return JSON.parse(jsonInfo);
        }

        return;
    }

    login(credentials): Observable<any> {
        var companyId = this.companyService.getIdFromUrl();

        return this.http.post(API.login, {
            userId: credentials.userId,
            password: credentials.password,
            company: companyId,
        }).map(authenticateSuccess.bind(this));

        function authenticateSuccess(resp: Response) {
            if (!resp.json || (resp.json && resp.json().code !== 1)) {
                return '';
            }

            const jwt = resp.json().data.token;
            this.storeAuthenticationToken(jwt, resp.json().data);

            return jwt;
        }
    }

    storeAuthenticationToken(jwt, info) {
        this.$localStorage.store('authenticationToken', jwt);
        this.$localStorage.store('authenticationInfo', JSON.stringify(info));
    }

    logout(): Observable<any> {
        return new Observable((observer) => {
            this.$localStorage.clear('authenticationToken');
            this.$localStorage.clear('authenticationInfo');

            observer.complete();
        });
    }
}
